/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type UpdateUserConfirmedPaidComputeMutationVariables = Types.Exact<{
  confirmed: Types.Scalars["Boolean"]["input"];
}>;

export type UpdateUserConfirmedPaidComputeMutation = {
  readonly __typename: "Mutation";
  readonly updateUserConfirmedPaidCompute: {
    readonly __typename: "User";
    readonly id: c.UserId;
    readonly confirmedPaidCompute: boolean;
  };
};

export const UpdateUserConfirmedPaidComputeDocument = /*#__PURE__*/ gql`
  mutation UpdateUserConfirmedPaidCompute($confirmed: Boolean!) {
    updateUserConfirmedPaidCompute(confirmed: $confirmed) {
      id
      confirmedPaidCompute
    }
  }
`;
export type UpdateUserConfirmedPaidComputeMutationFn = Apollo.MutationFunction<
  UpdateUserConfirmedPaidComputeMutation,
  UpdateUserConfirmedPaidComputeMutationVariables
>;

/**
 * __useUpdateUserConfirmedPaidComputeMutation__
 *
 * To run a mutation, you first call `useUpdateUserConfirmedPaidComputeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserConfirmedPaidComputeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserConfirmedPaidComputeMutation, { data, loading, error }] = useUpdateUserConfirmedPaidComputeMutation({
 *   variables: {
 *      confirmed: // value for 'confirmed'
 *   },
 * });
 */
export function useUpdateUserConfirmedPaidComputeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUserConfirmedPaidComputeMutation,
    UpdateUserConfirmedPaidComputeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateUserConfirmedPaidComputeMutation,
    UpdateUserConfirmedPaidComputeMutationVariables
  >(UpdateUserConfirmedPaidComputeDocument, options);
}
export type UpdateUserConfirmedPaidComputeMutationHookResult = ReturnType<
  typeof useUpdateUserConfirmedPaidComputeMutation
>;
export type UpdateUserConfirmedPaidComputeMutationResult =
  Apollo.MutationResult<UpdateUserConfirmedPaidComputeMutation>;
export type UpdateUserConfirmedPaidComputeMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateUserConfirmedPaidComputeMutation,
    UpdateUserConfirmedPaidComputeMutationVariables
  >;
